import React, { useEffect, useState } from "react";
import { Form, Input, Modal ,theme } from "antd";
import { POST, PATCH } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import ErrorMessages from "../../../common/ErrorMessages";

export default function ShippingLocationListModal (props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages , setErrorMessages] = useState(null);

  useEffect(() => {
    if (target) {
      form.setFieldsValue(target);
    } else {
      form.resetFields();
    }
  }, [open]);


  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if (target?.id) {
        await PATCH(`${URL_SETTING.LOCATION}${target.id}/`, data);
      } else {
        await POST(URL_SETTING.LOCATION, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return (
 
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขด่าน (Location)" : "เพิ่มด่าน (Location)"}
      width={500}
      onOk={handleOK}
      destroyOnClose
      centered
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >

      <ErrorMessages message={errorMessages}/>
      
      <Form
        form={form}
        layout="vertical"
        style={{ padding: "10px 20px" }}
      >
        <Form.Item
          label="ด่าน (Location)"
          name="name"
          rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
        >
          <Input placeholder="ชื่อ สถานที่" />
        </Form.Item>
      </Form>
    </Modal>
  );
}